<template>
  <v-card
    :loading="loading"
    class="ma-md-5 ma-lg-10"
  >
    <template v-if="!loading && loaded && elementData != null">
      <v-card-title class="card_title" v-if="!hideViewTitle">
        <div class="container_title">
          <v-breadcrumbs class="breadcrumbs_title" v-if="crumbs.length > 1  &&
              (!this.user.hasIosUser())"
              :items="crumbs.map((el, $index) => ({ $index, ...el, }))"
              >
            <template v-slot:item="{ item }" >
              <v-breadcrumbs-item
              :to="getPreviousPath(item, crumbs.length)"
              :disabled="item.disabled"
              :exact=true
              >
                <div class="show_web">
                  <v-icon
                    color="primary"
                    v-if="item.$index === 0"
                  >{{ item.text }} </v-icon>
                  <template v-else-if="item.$index === crumbs.length - 1">
                    <h5 class="text-subtitle-1 black--text">
                      {{ elementData.name }}
                    </h5>
                  </template>
                  <template v-else>{{ item.text }}</template>
                </div>
                <div class="show_mobile">
                  <v-icon
                    color="primary"
                    v-if="item.$index === 0"
                  >{{ item.text }} </v-icon>
                </div>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
          <v-spacer></v-spacer>
          <div class="contentActions">
            <div class="ki-actions justify-end col-auto px-0 pt-0 pb-0"
            :style="{ borderColor: 'rgb(39, 132, 109)', height: '85px !important'  }">
            <v-btn
            :key="'compartir'"
                bottom
                right
                direction="top"
                transition="slide-y-reverse-transition"
                class="action_btn ml-4 v-btn v-btn--icon v-btn--round
                theme--light v-size--default iconHover"
                color="primary--text blue-grey lighten-4"
                dark
                icon @click.stop="$event => share($event)"
                @mouseover="actionHovered = 'c'"
                @mouseleave="actionHovered = null"
                >
                  <v-icon
                  :style="{color:'#757575'}"
                  >
                    mdi-share-variant
                  </v-icon>
                </v-btn>
                <div v-if="actionHovered === 'c'" class="messageIcon">
                  <v-scroll-y-transition>
                    <p
                    class="text-body mb-0 messageIconP"
                    >{{ $t(`views.knowledgeItems.share.title`) }}</p>
                  </v-scroll-y-transition>
                </div>
            </div>

            <div class="ki-actions justify-end col-auto px-0 pt-0 pb-0"
            :style="{ borderColor: 'rgb(39, 132, 109)', height: '85px !important' }">
                <v-btn
                  bottom
                  right
                  direction="top"
                  transition="slide-y-reverse-transition"
                  class="action_btn ml-4 v-btn v-btn--icon v-btn--round
                  theme--light v-size--default iconHover"
                  color="primary--text blue-grey lighten-4"
                  dark
                  icon @click.stop="$event => toggleFav($event)"
                  @mouseover="actionHovered = 'f'"
                  @mouseleave="actionHovered = null"
                  >
                  <v-icon
                  :style="{color:'#757575'}"
                  >
                      {{ isElementInBookmark()
                      ? 'mdi-bookmark' : 'mdi-bookmark-outline' }}
                  </v-icon>
                </v-btn>
                <div v-if="actionHovered === 'f'" class="messageIcon">
                  <v-scroll-y-transition>
                      <p
                      class="text-body mb-0 messageIconP"
                      >{{ $t(`views.knowledgeItems.fav.title`) }}</p>
                  </v-scroll-y-transition>
                </div>
            </div>
          </div>
        </div>
        <div class="show_mobile" id="breadcrumbs-mobile">
          <h5
            :style="{marginLeft: '1rem', overflowWrap: 'normal', wordBreak: 'normal'}">
            {{ crumbs[crumbs.length - 1].text}}
          </h5>
        </div>
        <ShareDialog
          :visible="openDialog"
          @input="openDialog = false"
          :item="sharedItem || {}"
          :positionX="sharedDialogPosition.positionX"
          :positionY="sharedDialogPosition.positionY"
        ></ShareDialog>
        <!-- <v-btn
          :class="['mr-2', 'mr-md-4', {
            'primary--text': $vuetify.breakpoint.mdAndUp
          }]"
          :to="link"
          :icon="$vuetify.breakpoint.smAndDown"
          :outlined="$vuetify.breakpoint.mdAndUp"
          :rounded="$vuetify.breakpoint.mdAndUp"
        >
          <v-icon>mdi-menu-left</v-icon>
          <span v-if="$vuetify.breakpoint.mdAndUp
            && ( categoryId != null || getCategory() != null )
          ">
            {{ getCategory() != null ? getCategory().name : categoryId }}
          </span>
        </v-btn>

        {{ elementData.name }}-->
      </v-card-title>
      <Form
        :id="`request-${elementIdData}`"
        :data="elementData"
        :lock="submitting"
        :key="`request-form-${elementIdData}`"
        ref="form"
        class="pa-4"
        :buttons="noData ? [] : formSubmitButtons"
        @click:submit="createTicket"
        :submitVisible="!noData"
        :showButtons="funShowButtons"
      ></Form>
      <!--

          <v-btn
            color="primary"
            @click="createTicket"
          >{{ $t('views.form.create') }}</v-btn>
          <v-btn
            color="secondary"
            @click="createTicket($event, true)"
          >{{ $t('views.form.createAndResolve') }}</v-btn>

      -->
    </template>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Form, ShareDialog } from '@/components';
import { NAMED_ROLES } from '@/store/modules/session';
import { STATUS } from '@/store/modules/catalog';
import { STATUS as BOOKMARKS_STATUS, BOOKMARK_TYPES } from '@/store/modules/bookmarks';

const PATH_LOGIN = '/login';
const PATH_HOME = '/';
let DEBE_ACTUALIZAR_LOCALIZACION = false;

const ticketTypeToBookmarkType = (type) => {
  switch (type) {
  default:
  case 'R': return BOOKMARK_TYPES.REQUESTS;
  case 'I': return BOOKMARK_TYPES.INCIDENTS;
  }
};

export default {
  props: {
    ticketType: String,
    categoryId: String,
    categoryParent: String,
    elementId: String,
    queryParams: {
      type: Object,
      default: () => ({}),
    },
    idTicket: Number,
    method: String,
    hideViewTitle: {
      type: Boolean,
      default: () => false,
    },
    internalAccess: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
    },
  },
  components: { Form, ShareDialog },
  data() {
    return {
      loading: false,
      submitting: false,
      error: null,
      elementCopy: null,
      prevRoute: null,
      sharedItem: null,
      sharedDialogPosition: {},
      openDialog: false,
      isApproverZero: false,
      approverZeroName: '',
      prevFullRoute: null,
      elementData: null,
      ticketTypeData: null,
      elementIdData: null,
      prevFullPathSearch: '/search',
      actionHovered: null,
      dataFeedback: null,
      dataCategoryId: null,
      isErrorCreate: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { path, fullPath } = from;
      let prevRoute = path.substr(1); // removes first slash
      const nextSlashIndex = prevRoute.indexOf('/');
      if (nextSlashIndex !== -1) {
        prevRoute = prevRoute.substr(0, nextSlashIndex);
      }
      // eslint-disable-next-line no-param-reassign
      vm.prevRoute = {
        path: `/${prevRoute}`,
        prevFullPath: fullPath,
      };
    });
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchForm',
    element: async function initializeElementProperties(el) {
      const idform = el.id;
      const { id: idElement, location: { id: idWorkplace } } = el;
      this.elementId = idElement;
      this.elementIdData = this.elementId;
      this.workplaceId = idWorkplace;
      localStorage.setItem('elementId', idElement);
      localStorage.setItem('workplaceId', idWorkplace);

      if (this.hasGroupTIC()) {
        try {
          this.isWorkFlow = await this.searchWorkFlow(idElement, idWorkplace);
        } catch (err) {
          this.isWorkFlow = false;
          console.log(err);
        }
      }

      if (this.queryParams != null) {
        Object.keys(this.queryParams)
          .forEach((key) => {
            const property = el.properties.find(
              (prop) => prop.alias === key,
            );
            if (property) {
              property.config = {
                initialvalue: `"${this.queryParams[key]}"`,
              };
            }
          });
      }
      if (el) {
        const { properties } = el;

        // elementForInsert
        const elementForInsert = properties
          .filter((elementData) => elementData?.special_values?.workflowInsert) || [];
        const dataForInsert = {
          id: idform,
          props: elementForInsert,
        };
        localStorage.setItem('elementForInsert', JSON.stringify(dataForInsert));

        // elementForUpdate
        const elementForUpdate = properties
          .filter((elementData) => elementData?.special_values?.workflowUpdate) || [];
        const dataForUpdate = {
          id: idform,
          props: elementForUpdate,
        };
        localStorage.setItem('elementForUpdate', JSON.stringify(dataForUpdate));
      }
      return el;
    },
    internalAccess: {
      handler: function (newVal) { // eslint-disable-line
        if (newVal) {
          const [ticketType, elementId] = this.id.split('/');
          this.ticketTypeData = ticketType;
          this.elementIdData = elementId;
          this.fetchForm();
        }
      },
    },
  },
  async created() {
    localStorage.removeItem('suscriptorsList');
    this.prevFullPathSearch = '/search';
    if (this.internalAccess) {
      const [ticketType, elementId] = this.id.split('/');
      this.ticketType = ticketType.toUpperCase();
      this.elementId = elementId;
      this.ticketTypeData = this.ticketType;
      this.elementIdData = this.elementId;
      this.fetchForm();
    } else {
      this.ticketTypeData = this.ticketType;
      this.elementIdData = this.elementId;
      if (!this.$store.getters['catalog/loaded'](this.ticketTypeData, this.categoryId)) {
        this.$store.dispatch('catalog/loadCatalogCategories', {
          userId: this.user.id,
          locationId: this.user.location.id,
          type: this.ticketTypeData,
        });
      }
      if (this.categoryId != null && !this.$store.getters['catalog/storedElements'](this.ticketTypeData, this.categoryId)) {
        this.$store.dispatch('catalog/loadCategoryElements', {
          categoryId: this.categoryId,
          type: this.ticketTypeData,
        });
      }
      const bookmarkType = ticketTypeToBookmarkType(this.ticketTypeData);
      const bookmarkTypeStatus = this.$store.getters['bookmarks/status'](bookmarkType);
      // if bookmarks[type] are not loaded yet we will request them
      if (![BOOKMARKS_STATUS.SUCCESS, BOOKMARKS_STATUS.LOADING].includes(bookmarkTypeStatus)) {
        this.$store.dispatch('bookmarks/get', { type: bookmarkType });
      }
      if (this.method === 'clone') {
        this.fetchCloneForm();
      } else {
        this.fetchForm();
      }
      this.$root.$on('Updatesearch', async (workplace) => {
        if (this.hasGroupTIC() && workplace) {
          const { value: workplaceId } = workplace;
          try {
            this.isWorkFlow = await this.searchWorkFlow(this.elementIdData, workplaceId);
          } catch (err) {
            this.isWorkFlow = false;
            console.log(err);
          }
        } else {
          this.isWorkFlow = false;
        }
      });
    }
  },
  methods: {
    // eslint-disable-next-line consistent-return
    async fetchForm() {
      this.error = null;
      this.form = null;

      this.loading = true;

      try {
        if (this.elementData == null && this.elementIdData != null) {
          await this.$store.dispatch('catalog/loadElement', {
            elementId: this.elementIdData,
            type: this.ticketTypeData,
          });
        }
      } catch (ex) {
        this.error = ex;
        /* Segun el ex.status 403 para falta de permisos y 404 url no encontrada */
        this.$store.dispatch('messages/createNotificationMessage', {
          title: ex.status === 403
            ? this.$t('ticketActions.noViewPage') : this.$t('ticketActions.noViewExist'),
          type: 'error',
          timeout: this.$getConst('notifications.timeoutPlus'),
          dismissible: true,
        });

        this.$router.push('/');
      }
      this.loading = false;
    },
    async fetchCloneForm() {
      this.error = null;
      this.form = null;

      this.loading = true;
      try {
        const response = await this.$api.getClient('catalog').getElementClone(
          this.idTicket,
          this.elementIdData,
        );
        if (response) {
          const dataForm = response.list[0].properties;
          const ASIG_INITIAL = 'Asignación inicial';
          for (let x = 0; x < dataForm.length; x += 1) {
            if (
              dataForm[x].name === ASIG_INITIAL
              && dataForm[x].config != null
              && dataForm[x].config.initialvalue != null
            ) {
              dataForm[x].config.initialvalue = '';
            }
          }
        }
        this.elementCopy = response.unique();
      } catch (ex) {
        this.error = ex;
      }
      this.loading = false;
    },

    async createTicket($evt) {
      this.isErrorCreate = false;
      const { action, data, attachments } = $evt;
      const resolve = action === this.$t('views.form.createAndResolve');

      const notificationMessageId = await this.$store.dispatch('messages/createNotificationMessage', {
        title: this.$t('views.form.messages.creating'),
        icon: 'progress-circular',
      });

      try {
        this.submitting = true;

        try {
          const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
          let accessKey = '';
          let token = '';

          if (isMobile === true) {
            this.queryParams.isMobile = true;
            accessKey = (this.$store.getters['session/storage'] || {}).access_key;
            token = (this.$store.getters['session/storage'] || {}).token;
          }
          const isNavInternal = this.navInternal;
          if (isNavInternal) {
            console.log('internalQueryParams.srcchn---------------------------', this.internalQueryParams.srcchn);
            console.log('internalQueryParams.typechn--------------------------', this.internalQueryParams.typechn);
            console.log('internalQueryParams.idchn----------------------------', this.internalQueryParams.idchn);
            this.queryParams.srcchn = this.internalQueryParams.srcchn;
            this.queryParams.typechn = this.internalQueryParams.typechn;
            this.queryParams.idchn = this.internalQueryParams.idchn;
          }

          this.dataFeedback = data.feedback;
          delete data.feedback;
          const response = await this.$api.getClient('ticket').create(this.elementIdData, this.ticketTypeData, data, resolve, this.queryParams);
          this.dataResponse = response;
          if (!response.total) {
            throw new Error('there was an unexpected error in ticket creation: got empty response (total = 0)');
          }

          const ticket = response.unique();
          this.dataCategoryId = ticket?.category?.id;

          this.updateUserLocationIfNeeded(data.workplace, ticket.customer);

          // const url = resolve ? `/requests/${ticket.id}?action=resolve`
          // : `/requests/${ticket.id}`;
          /* Nueva Vista Registro Solicitud */
          const url = resolve ? `/requests/registered/${(ticket.type.relAttr).toLowerCase()}/${ticket.id}/${ticket.name}?action=resolve`
            : `/requests/registered/${(ticket.type.relAttr).toLowerCase()}/${ticket.id}/${ticket.name}`;
          this.$router.push(url);

          const totalAttachments = attachments.concat(
            ticket.$attachments.map((attmnt) => {
              const buffer = Buffer.from(attmnt.fichero);
              if (attmnt.name) {
                buffer.name = attmnt.name;
              }
              return buffer;
            }),
          );

          if (totalAttachments.length) {
            const attachmentsClient = this.$api.getClient('attachment');
            const updateMessageStatus = (currentUpload) => {
              this.$store.dispatch('messages/updateMessage', {
                id: notificationMessageId,
                title: this.$t('views.form.messages.uploadingAttachments', [currentUpload, totalAttachments.length]),
              });
            };

            await totalAttachments.reduce((p, attmnt, idx) => p.then(async () => {
              updateMessageStatus(idx + 1);

              if (isMobile) {
                await attachmentsClient.uploadApp(
                  attmnt, ticket.id, this.user.userid, ticket.referenceNumber,
                  this.$getConst('upload.server'), this.$getConst('upload.rep'),
                  ticket.getPortafirmasRequestId(), accessKey, token, window.location.pathname,
                );
              } else {
                await attachmentsClient.upload(attmnt,
                  ticket.id, this.user.userid, ticket.referenceNumber,
                  this.$getConst('upload.server'), this.$getConst('upload.rep'),
                  ticket.getPortafirmasRequestId());
              }
            }), Promise.resolve());
          }

          if (ticket.hasPortafirmasRequest()) {
            await this.$api.getClient('ticket').sendPfirmas(ticket.id);
            console.log('pfirmas request sent');
          }

          this.$store.dispatch('messages/updateMessage', {
            id: notificationMessageId,
            title: this.$t(`views.form.messages.created.${this.ticketTypeData}`),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeout'),
          });
        } catch (ex) {
          console.error('error creating ticket', ex, this.elementIdData, data, this);
          const errEX = ex;
          let errorCgesCode = '';
          if (errEX && errEX.data && errEX.data.errorCgesCode) {
            errorCgesCode = errEX.data.errorCgesCode;
          }
          this.$store.dispatch('messages/updateMessage', {
            id: notificationMessageId,
            title: this.$t('views.form.messages.error', [errorCgesCode]),
            icon: 'mdi-times',
            type: 'error',
            timeout: this.$getConst('notifications.timeout'),
          });
        }

        this.submitting = false;
      } catch (ex) {
        this.isErrorCreate = true;
        console.log('reject resolve message dialog:', ex.message);
      }

      try {
        const { id: uuid, userid, dni } = this.user;
        this.$api.getClient('solicitudes').rate({
          canal: 7,
          uuid,
          username: userid,
          dni,
          codigo: 'PCAT',
          id: this.elementData.category.id,
          name: '¿Cómo ha sido el proceso de registro?',
          valoracion: this.dataFeedback.starsScore,
          comment: this.dataFeedback.comment,
        });

        if (this.isErrorCreate) return false;
        return true;
      } catch (ex) {
        if (this.isErrorCreate) return false;
        return true;
      }
    },
    updateUserLocationIfNeeded(newWorkplace, customer) {
      const formRef = this.$refs.form;
      if (formRef != null
        && formRef.shouldUpdateUserLocation()
        && newWorkplace != null) {
        const userData = {
          location: newWorkplace,
          requestedBy: customer.id,
        };

        DEBE_ACTUALIZAR_LOCALIZACION = this.user.id === customer.id;

        this.$api.getClient('user').update(userData).then(() => {
          if (DEBE_ACTUALIZAR_LOCALIZACION) {
            this.$store.dispatch('session/updateLocation', newWorkplace);
          }
        });
      }
    },
    getCategory() {
      if (this.categoryId != null && this.ticketTypeData != null) {
        const typedCategories = this.$store.state.catalog.categories[this.ticketTypeData];
        return typedCategories[this.categoryId] != null
          ? typedCategories[this.categoryId].model
          : null;
      }
      return (this.element || {}).catalogCategory || null;
    },
    isElementInBookmark() {
      const type = ticketTypeToBookmarkType(this.ticketTypeData);
      return this.$store.getters['bookmarks/isInBookmark'](type, this.elementIdData);
    },
    async toggleFav(evt) {
      evt.preventDefault();

      const action = this.isElementInBookmark(this.elementIdData) ? 'bookmarks/remove' : 'bookmarks/add';
      try {
        await this.$store.dispatch(action, {
          type: ticketTypeToBookmarkType(this.ticketTypeData),
          element: {
            id: this.elementIdData,
            name: this.elementData.name,
          },
        });
      } catch (ex) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('ticketActions.messages.error'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    share(evt) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: `${this.$t(`components.share.subjectBody.${this.ticketTypeData}`)} ${this.elementData.name}`,
          url: `${window.location.origin}${this.$router.options.base}element/${this.ticketTypeData.toLowerCase()}/${this.elementIdData}`,
          formName: this.elementData.name,
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}element/${this.ticketTypeData.toLowerCase()}/${this.elementIdData}`;
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t(`components.share.subjectBody.${this.ticketTypeData}`)} ${this.elementData.name}`,
          url: fullShareUrl,
          formName: this.elementData.name,
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    hasGroupTIC() {
      return this.user.ticGroupMember;
    },
    async searchWorkFlow(elementId, idWorkplace) {
      const client = this.$api.getClient('search');
      try {
        const response = await client.search({
          target: 'namedquery',
          entity: 'ticketApprovalWorkflowTemplate',
          filters: {
            elementData: elementId,
            location: idWorkplace,
          },
        });

        return response.list.length > 0;
      } catch (err) {
        return err;
      }
    },
    getPreviousPath(item, crumbsLength) {
      if (item.$index < crumbsLength - 1) {
        if ((item.to).includes('search')) {
          return this.prevRoute.prevFullPath;
        }
        return item.to;
      }
      return undefined;
    },
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      navInternal: 'routeState/getNavInternal',
      internalQueryParams: 'routeState/getInternalQueryParams',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
      loaded: ({ catalog: { status } }) => [STATUS.SUCCESS, STATUS.ERROR].includes(status),
      element: function mapElement({ catalog }) {
        // create a copy of the element to prevent
        // query params initialvalues caching
        const element = this.elementCopy !== null
          ? this.elementCopy : catalog.elements[this.elementIdData];

        const res = element != null ? ({
          ...element,
          properties: element.properties.map(
            (property) => ({ ...property }),
          ),
        }) : null;

        if (res != null) this.elementData = res;
        return res;
      },
    }),
    noData() {
      // verify if element properties are only of type 'description'
      // to hide submit buttons (the element will be considered as info element)
      return this.elementData != null
        && this.elementData.properties.length
        && this.elementData.properties.every((property) => property.type.name === 'description' || (property.params || {}).save === 'false');
    },
    formSubmitButtons() {
      let submitButtons = [this.$t('views.form.create')];
      if (this.hasRoles(NAMED_ROLES.VIEW_CSU) || (this.hasGroupTIC() && !this.isWorkFlow)) {
        submitButtons.push(this.$t('views.form.createAndResolve'));
      }
      const elementosConDisableSubmit = this.elementData.properties.filter(item => item.config?.disableSubmit === 'true' && item.alias === 'deshabilitarCrear'); //eslint-disable-line

      if (elementosConDisableSubmit.length > 0) {
        submitButtons = [];
      }
      return submitButtons;
    },
    funShowButtons() {
      const elementosConDisableSubmit = this.elementData.properties.filter(item => item.config?.disableSubmit === 'true' && item.alias === 'deshabilitarCrear'); //eslint-disable-line
      if (elementosConDisableSubmit.length > 0) {
        return false;
      }
      return true;
    },
    link() {
      const url = {
        R: `/request/${this.categoryId ? this.categoryId : ''}`,
        I: '/incident/',
        default: '/',
      };
      return url[this.ticketTypeData] || url.default;
    },
    crumbs() {
      const routePath = this.$route.path.endsWith('/') ? this.$route.path.slice(0, -1) : this.$route.path;
      const paths = routePath.split('/');
      paths.slice(0, 1); // remove first slash
      const category = this.getCategory();
      const { element } = this;

      const prevPath = (this.prevRoute && this.prevRoute.path === PATH_LOGIN)
        ? PATH_HOME
        : (this.prevRoute || {}).path || PATH_HOME;

      const breadcrumbs = [{
        path: paths.splice(0, 1),
        text: 'mdi-keyboard-backspace',
        to: prevPath === this.$route.path ? '/home' : prevPath,
      }];

      const effectiveCategoryId = this.categoryId != null ? this.categoryId : (category || {}).id;
      if (effectiveCategoryId != null && this.ticketTypeData === 'R' && this.$vuetify.breakpoint.mdAndUp) {
        let path = '';
        if (this.categoryId != null) {
          if (this.categoryParent) {
            path = paths.splice(0, 4).join('/');
          } else {
            path = paths.splice(0, 2).join('/');
          }
        }

        const categoryListPrefix = { R: '/request', I: '/incident' }[this.ticketTypeData] || '/request';
        breadcrumbs.push({
          path,
          to: this.categoryId != null
            ? `${breadcrumbs[0].path}/${path}`
            : `${categoryListPrefix}/${effectiveCategoryId}`,
          text: category != null ? category.name : effectiveCategoryId,
        });
      }

      breadcrumbs.push({
        text: element != null ? element.name : this.elementIdData,
      });
      return breadcrumbs;
    },
    NAMED_ROLES: () => NAMED_ROLES,
  },
};

</script>
<style lang="scss" scoped>
  .text-subtitle-1 {
    word-break: break-word;

    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }
  .ki-actions {
    position: relative;
    padding-top: 18px !important;

    > button {
      width: 55px !important;
      height: 55px !important;
      border-radius: 50%;
      border-color: inherit;
      border-width: 2px;
      border-style: solid;
      background-color: white;

      &:last-child .ki-action-name.right {
        left: 100%;
        display: table;
        transform: translateX(-100%);
      }
    }

    .ki-action-name {
      pointer-events: none;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .contentActions{
    display: flex;
    //width: 100%;
    justify-content: end;
  }
  .messageIcon{
    max-width: 55px;
  }
  .messageIconP{
    font-size: 0.875rem !important;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: 500 !important;
    letter-spacing: 0.0892857143em !important;
    text-indent: 0.0892857143em !important;
    text-transform: uppercase !important;
    white-space: nowrap !important;
  }

  .show_mobile {
    display: none;
  }

  .container_title {
    display:flex;
    width: 100%
  }
@media (max-width: 600px) {
  .container_title {
    height: 4rem !important;
  }

  .card_title {
    padding-left: 0px !important;
    display: flex;
    align-items: center;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .show_web {
    display: none;
  }

  .show_mobile {
    display: block;
  }

  .v-breadcrumbs {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  #breadcrumbs-mobile {
    margin-top: -1rem;
  }

  .mdi-keyboard-backspace::before {
    font-size: 22px;
  }

  .v-breadcrumbs__divider {
    font-size: large;
  }

  .ki-actions {
    border: none !important;
    margin: 0px !important;
    padding: 0px !important;
  }

  .action_btn {
    margin: 0px !important;
  }

  .messageIconP {
    margin-left: -1rem !important;
  }
}
</style>
